import useGreeksWebsocketDataStore from '../../Store/GreeksWebsocketDataStore';

export const totalThetaGetter = function (PineJS) {
  return Promise.resolve([
    {
      name: 'SPX_Total_Charm',
      metainfo: {
        metainfoVersion: 53,
        id: "SPX_Total_Charm@tv-basicstudies-1",
        description: "SPX Total Charm",
        shortDescription: "SPX Total Charm",
        linkedToSeries: true,
        is_price_study: false,
        format: { type: "price" },
        plots: [
          {
            id: "net_theta",
            type: "line",
            title: "Net Theta",
            trackPrice: true,
            transparency: 70,
            fillGaps: true
          },
          {
            id: "zero_line",
            type: "line",
            title: "Zero Line"
          }
        ],
        defaults: {
          styles: {
            net_theta: {
              linestyle: 0,
              linewidth: 1,
              plottype: 8,
              trackPrice: false,
              transparency: 60,
              visible: true,
              color: "#eeeb2b",

            },
            zero_line: {
              linestyle: 0,
              linewidth: 1,
              color: "#ffffff",
              visible: true
            }
          },
          precision: 2,
          inputs: {}
        },
        styles: {
          net_theta: { title: "Net Theta", histogramBase: 8 },
          zero_line: { title: "Zero Line" }
        },
        inputs: []
      },
      constructor: function () {
        this._debugMode = true;

        this.init = function (ctx) {
          this._context = ctx;
        };

        this.main = function (ctx) {
          try {
            const { greekExposures } = useGreeksWebsocketDataStore.getState();
            const spxExposures = greekExposures.spx;

            if (!spxExposures?.length) {
              if (this._debugMode) {
                // console.log('[totalThetaGetter] No greek exposures data');
              }
              return [null, null];
            }

            const time = ctx.symbol.time;
            if (!time || isNaN(time)) {
              if (this._debugMode) {
                // console.log('[totalThetaGetter] Invalid symbol time:', time);
              }
              return [null, null];
            }

            const timeInSec = Math.floor(time / 1000);

            const thetaExposures = spxExposures
              .filter(exp => exp.greek_type === 'theta')
              .sort((a, b) => a.timestamp - b.timestamp);

            if (!thetaExposures.length) {
              return [null, null];
            }

            let closestExp = thetaExposures[0];
            let minDiff = Math.abs(closestExp.timestamp - timeInSec);

            for (const exp of thetaExposures) {
              const diff = Math.abs(exp.timestamp - timeInSec);

              if (diff < minDiff) {
                minDiff = diff;
                closestExp = exp;
              }
            }

            const value = parseFloat(closestExp.net_exposure) || 0;

            return [value, 0];  // Return both the theta value and zero line
          } catch (err) {
            return [null, null];
          }
        };

        this.destroy = function() {
          // No cleanup needed since we're not using subscriptions
        };
      }
    }
  ]);
};